import React from 'react';
import CompanyInfoTab from './companyInfo/CompanyInfo';
import VeteranOwnerInfoTab from './veteranOwnerInfo/VeteranOwnerInfo';
import BusinessStructureTab from './businessStructure/BusinessStructure';
import BusinessCertificationTab from './businessCertification/BusinessCertification';
import FinancialDocumentsTab from './financialDocuments/FinancialDocuments';
import TaxInfoTab from './taxInfo/TaxInfo';
import BankInfoTab from './bankInfo/BankInfo';
import EquipmentInfoTab from './equipmentInfo/EquipmentInfo';
import ArticlesTab from './articles/Articles';
import DeclarationTab from './declaration/Declaration';
import AppReviewTab from '../appReview/AppReview';
import CertReviewTab from '../certReview/CertReview';
import AssignTab from '../assign/Assign';
import FinalReviewTab from '../finalReview/FinalReview';
import CommReviewTab from '../commReview/CommReview';
import FinalRecommTab from '../siteReview/siteReviewInfo/finalRecomm/FinalRecomm';
import AuditInfo from './auditInfo/AuditInfo';
import { SetupPage } from 'areas/shared/pages/setup';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import * as App from 'modules/app/App';
import { TooltipCategory } from 'areas/shared/consts';

class CertificationSetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [{ columns: [] }],
            loading: true,
            data: { availableQueues: [] }
        };
    }

    componentDidMount() {
        this.getCertificationSetup();
    }

    handleBackToSearchQueue = () => {
        var params = "";
        if (App.context().searchQueueFilters)
            params = "?p=true";

        this.props.history.push('/admin/searchQueue' + params);
    }

    getCertificationSetup = () => {

        var certificationKey = this.props.location.pathname.replace(this.props.match.path + "/", '');
        if (certificationKey.indexOf("/") > 0)
            certificationKey = certificationKey.substring(0, certificationKey.indexOf("/"));

        var rq = {
            certificationKey: certificationKey
        };

        new API().post(APIModules.Admin.url('/certification/getCertificationSetup'), rq,
            {
                success: (r) => {
                    this.setState(
                        {
                            data: r.data,
                            loading: false
                        }
                    );
                }
            });
    }

    render() {
        var me = this;

		if (this.state.loading)
            return null;

        var tabs = [
            { key: "companyInfo", title: "Company", comp: CompanyInfoTab, helpKey: "", tooltips: this.state.data.tooltips[TooltipCategory.COMPANY_INFO] },
            { key: "veteranOwnerInfo", title: "Veterans", comp: VeteranOwnerInfoTab, helpKey: "", tooltips: this.state.data.tooltips[TooltipCategory.VETERAN_INFO] },
            { key: "businessStructure", title: "Business Struc.", comp: BusinessStructureTab, helpKey: "", disabled: this.state.data.businessStructureDisabled, tooltips: this.state.data.tooltips[TooltipCategory.BUSINESS_STRUCTURE] },
            { key: "businessCertification", title: "Cert.", comp: BusinessCertificationTab, helpKey: "", disabled: this.state.data.businessCertificationDisabled, tooltips: this.state.data.tooltips[TooltipCategory.CERTIFICATIONS] },
            { key: "financialDocuments", title: "Finances", comp: FinancialDocumentsTab, helpKey: "", disabled: this.state.data.financesDisabled, tooltips: this.state.data.tooltips[TooltipCategory.FINANCES] },
            { key: "bankInfo", title: "Banking", comp: BankInfoTab, helpKey: "", disabled: this.state.data.bankingDisabled, tooltips: this.state.data.tooltips[TooltipCategory.BANKING] },
            { key: "taxInfo", title: "Taxes", comp: TaxInfoTab, helpKey: "", disabled: this.state.data.taxesDisabled, tooltips: this.state.data.tooltips[TooltipCategory.TAXES] },
            { key: "equipmentInfo", title: "Equipment", comp: EquipmentInfoTab, helpKey: "", disabled: this.state.data.equipmentDisabled, tooltips: this.state.data.tooltips[TooltipCategory.EQUIPMENT] },
            { key: "articles", title: "Articles", comp: ArticlesTab, helpKey: "", disabled: this.state.data.articlesDisabled, tooltips: this.state.data.tooltips[TooltipCategory.ARTICLES] },
        ];

        if (this.state.data.showDeclaration)
            tabs.push({ key: "declaration", title: "Declaration", comp: DeclarationTab, helpKey: "", tooltips: this.state.data.tooltips[TooltipCategory.DECLARATION] });

        if (this.state.data.availableQueues.includes('APP'))
            tabs.push({ key: "appReview", title: "App Review", comp: AppReviewTab, helpKey: "" });

        if (this.state.data.availableQueues.includes('CER'))
            tabs.push({ key: "certReview", title: "Cert Review", comp: CertReviewTab, helpKey: "" });

        if (this.state.data.availableQueues.includes('COM'))
            tabs.push({ key: "comReview", title: "Comm Review", comp: CommReviewTab, helpKey: "" });
            
        if (this.state.data.availableQueues.includes('STR'))
            tabs.push({ key: "finalRecomm", title: "Site Review", comp: FinalRecommTab, helpKey: "" });

        if (this.state.data.availableQueues.includes('FIN'))
            tabs.push({ key: "finalReview", title: "Final Review", comp: FinalReviewTab, helpKey: "" });

        if (App.hasPrivilege("UnassignedQueue") && this.state.data.canAssignCertification)
            tabs.push({ key: "assign", title: "Assign", comp: AssignTab, helpKey: "" });

        tabs.push({ key: "CertificationAudit", title: "Audit", comp: AuditInfo, helpKey: "" });

        let opts = {
            title: "Search Queue - ",
            list: {
            },
            description: "Search and Manage Applications",
            recentType: "certification",
            tabs: tabs,
            sortField: false,
            _certificationSetup: me,
            daysOpen: this.state.data.inProgress ? this.state.data.daysOpen : null
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                customOnBack={this.handleBackToSearchQueue}
                showTitle={false} />
        );
    }
}

export default CertificationSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/CertificationSetup.js